import React from "react";
import { FeedbackCategory } from "../../../Constants/feedbackEnums";
import { feedbackCategoryService } from "../../../Services/FeedbackCategoryService";
import { BadgeButton } from "../../../../Layout/Components/BadgeButton/BadgeButton";

type Props = {
  category: FeedbackCategory;
};

const badgeColors = {
  [FeedbackCategory.BugReport as any]: {
    color: "#8D6673",
    textColor: "white"
  },
  [FeedbackCategory.FeatureRequest as any]: {
    color: "#1adbae",
    textColor: "black"
  },
  [FeedbackCategory.ResourceRequest as any]: {
    color: "#8403fc",
    textColor: "white"
  }
};

export const FeedbackCategoryBadge: React.FC<Props> = props => {
  const text = feedbackCategoryService.getDisplayNameForCategory(FeedbackCategory[props.category]);

  return (
    <BadgeButton
      {...badgeColors[props.category as any]}
      borderColor={badgeColors[props.category as any].color}
      disabled
    >
      {text}
    </BadgeButton>
  );
};

export default FeedbackCategoryBadge;
